import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reducers/RootReducer";
import { tickTimer } from "../../action/SpinToWinAction";

const useTimer = (_initialSeconds: number) => {
  const dispatch = useDispatch();
  const remainingSeconds = useSelector((state: RootState) => state.spinToWin.remainingSeconds);
  const isTimerPaused = useSelector((state: RootState) => state.spinToWin.isTimerPaused);

  useEffect(() => {
    // Paused once the design is submitted — the clock shouldn't run out while
    // the save is in flight or the confirmation is on screen.
    if (remainingSeconds <= 0 || isTimerPaused) return;

    const timer = setInterval(() => {
      dispatch(tickTimer());
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingSeconds, isTimerPaused, dispatch]);

  return { remainingSeconds };
};

export default useTimer;
